import { createContext, useEffect, useState } from 'react';
import {
  CartContextType,
  CartDetailType,
  ChildrenType,
} from '../interface/interface';
import { useAuth } from 'react-oidc-context';
import axios from '../config/axios';
import { userDetails } from '../utils/userDetail';

const CartContext = createContext({} as CartContextType);

const CartContextProvider = ({ children }: ChildrenType) => {
  const { user } = useAuth();
  const [cartDetail, setCartDetails] = useState<CartDetailType | undefined>();

  const callCart = async () => {
    try {
      const token = user?.access_token;

      if (!token) {
        return false;
      }

      const userDetail = await userDetails(token);

      if (userDetail?.role !== 'Patients') return false;

      const response = await axios('/api/v1/cart', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const responseData = response?.data;
      setCartDetails(responseData);
    } catch (error) {
      console.error('Failed to fetch card details');
    }
  };
  
  useEffect(() => {
    callCart();
  }, []);

  return (
    <CartContext.Provider value={{ cart: cartDetail, setCart: setCartDetails }}>
      {children}
    </CartContext.Provider>
  );
};

export { CartContext, CartContextProvider };
